import { freezeMap } from "./helpers.js";

const labs = [
  {
    title: "AIDEMEC",
    path: "../aidemec",
    logo: "/ll_logos/AIDEMEC.png",
    image: "/ll_images/AIDEMEC.png",
    country: "IT",
    region: "Mediterranean",
    coordinates: [40.575_348, 15.882_535],
    products: ["barley", "olive", "wheat", "tomato", "beans"],
    description: "Combines AI and agronomic tools to detect crop stress early, helping Mediterranean farmers protect yields from climate challenges.",
  },
  {
    title: "CONCATLL",
    path: "../concatll",
    logo: "/ll_logos/CONCATLL.png",
    image: "/ll_images/CONCATLL.png",
    country: "ES",
    region: "Mediterranean",
    coordinates: [41.586_168, 1.514_272],
    products: ["apple", "olive", "wheat", "poultry", "fish"],
    description: "Develops data-driven strategies to improve the resilience of Catalonia's agriculture against droughts, soil degradation, and other climate impacts.",
  },
  {
    title: "EcoReadyMasuria",
    path: "../ecoreadymasuria",
    logo: "/ll_logos/EcoReadyMasuria.png",
    image: "/ll_images/EcoReadyMasuria.png",
    country: "PL",
    region: "Central Europe",
    coordinates: [53.619_53, 20.366_513],
    products: ["barley", "maize", "sunflower", "red clover", "milk"],
    description: "A Polish innovation hub supporting farmers with climate adaptation trials, data collection, and policy recommendations to enhance food security and biodiversity.",
  },
  {
    title: "EcoVita LL",
    path: "../ecovitall",
    logo: "/ll_logos/EcoVitaLL.png",
    image: "/ll_images/EcoVitaLL.png",
    country: "HU",
    region: "Central Europe",
    coordinates: [47.492_367, 19.044_356],
    products: ["vertival farm", "leafy greens"],
    description: "Investigates vertical farming as a sustainable and resilient solution to address climate and food security challenges.",
  },
  {
    title: "Esappin",
    path: "../esappin",
    logo: "/ll_logos/Esappin.png",
    image: "/ll_images/Esappin.png",
    country: "DE",
    region: "Western Europe",
    coordinates: [51.443_657, 7.657_856],
    products: ["barley", "oats", "raspberry", "rapeseed", "mushroom"],
    description: "A German collaboration integrating academia, industry, and policy to advance sustainable farming practices and food security in North Rhine-Westphalia.",
  },
  {
    title: "LivOrganic",
    path: "../livorganic",
    logo: "/ll_logos/LivOrganic.png",
    image: "/ll_images/LivOrganic.png",
    country: "DK",
    region: "Scandinavia",
    coordinates: [55.939_112_079_462_35, 12.490_630_314_430_565],
    products: ["barley", "potato"],
    description: "Builds on Denmark's organic farming expertise to co-develop climate-adaptive, biodiversity-friendly solutions for food security in Scandinavia and the Baltic region.",
  },
  {
    title: "LOFS",
    path: "../lofs",
    logo: "/ll_logos/LOFS.png",
    image: "/ll_images/LOFS.png",
    country: "FR",
    region: "Western Europe",
    coordinates: [47.710_385, 1.727_322],
    products: ["mushroom", "grass"],
    description: "Addresses climate and biodiversity challenges in France's Loire Valley through future scenario modeling and farmer-driven adaptive strategies.",
  },
  {
    title: "Probio",
    path: "../probio",
    logo: "/ll_logos/Probio.png",
    image: "/ll_images/Probio.png",
    country: "CZ",
    region: "Central Europe",
    coordinates: [49.039_97, 16.864_949],
    products: ["apple", "olive", "wheat", "poultry", "fish"],
    description: "Harnesses 15+ years of organic farming experience to co-create solutions for biodiversity, ecosystem health, and sustainable agriculture.",
  },
  {
    title: "Seco Collab",
    path: "../secocollab",
    logo: "/ll_logos/SecoCollab.png",
    image: "/ll_images/SecoCollab.png",
    country: "SE",
    region: "Scandinavia",
    coordinates: [59.618_634_049_219_36, 16.540_738_729_629_07],
    products: ["vertical farm", "leafy greens"],
    description: "Focuses on vertical farming, and uses technology and data to promote sustainable, urban food production and climate-resilient consumption in Scandinavia and Europe.",
  },
  {
    title: "THALLA",
    path: "../thalla",
    logo: "/ll_logos/Thalla.png",
    image: "/ll_images/Thalla.png",
    country: "EL",
    region: "Mediterranean",
    coordinates: [38.533_333, 22.366_667],
    products: ["honey", "olive", "wheat", "tomato", "fish"],
    description: "Co-creates agroecological practices in Greece, tackling food security, biodiversity, and climate resilience through stakeholder collaboration.",
  },
];

export { labs };

export const LabsMap = freezeMap(new Map(labs.map((l) => [l.title.toUpperCase(), l])));
export const LabsByPathMap = freezeMap(new Map(labs.map((l) => [l.path, l])));

// Maps the `organization` identifier used by screen configs to the lab's country name.
// Single source of truth — replaces the duplicated countryMap in LcaAnalysis.js.
export const countryByOrganization = freezeMap(new Map([
	["aidemec", "Italy"],
	["concat_ll", "Spain"],
	["ecoready_masuria", "Poland"],
	["ecovitall", "Hungary"],
	["esappin", "Germany"],
	["livorganic", "Denmark"],
	["lofs", "France"],
	["probio", "Czech Republic"],
	["seco_collab", "Sweden"],
	["thalla", "Greece"],
]));
